import React from "react";
import FS_HOME_TRACKERGPS_LOGO from "../../../assets/img/FS-HOME-TRACKERGPS-LOGO.png";
import FS_HOME_FINDER_LOGO from "../../../assets/img/FS-HOME-FINDER-LOGO.png";
import FS_HOME_LOCALIZADO_LOGO from "../../../assets/img/FS-HOME-LOCALIZADO-LOGO.png";
import FS_HOME_POLARIX_LOGO from "../../../assets/img/FS-HOME-POLARIX-LOGO.png";
import "./LogosSection.scss";

function LogosSection({route}) {
  return (
    <div className={`max-width flex wrap space-around homeLogosSection-container top-space-section bottom-space-section ${route}`}>
      <div className="homeLogosSection-logo-container flex center-content-items mr-10 ml-10">
        <img src={FS_HOME_TRACKERGPS_LOGO} alt="FS_HOME_TRACKERGPS_LOGO" />
      </div>
      <div className="homeLogosSection-logo-container flex center-content-items mr-10 ml-10">
        <img src={FS_HOME_FINDER_LOGO} alt="FS_HOME_FINDER_LOGO" />
      </div>
      <div className="homeLogosSection-logo-container flex center-content-items mr-10 ml-10">
        <img src={FS_HOME_LOCALIZADO_LOGO} alt="FS_HOME_LOCALIZADO_LOGO" />
      </div>
      <div className="homeLogosSection-logo-container flex center-content-items mr-10 ml-10">
        <img src={FS_HOME_POLARIX_LOGO} alt="FS_HOME_POLARIX_LOGO" />
      </div>
    </div>
  );
}

export default LogosSection;
